// Reserved for future curriculum timeline interactions.
// Today-line positioning is handled via CSS calc() directly in the view.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {}
